export const LICENSE_CATEGORIES = ['B', 'C', 'C+E', 'C1', 'C1+E', 'D', 'D+E'] as const
export type LicenseCategory = typeof LICENSE_CATEGORIES[number]

export const DRIVER_QUALIFICATIONS = [
  'ADR_BASE',
  'ADR_TANK',
  'ADR_EXPLOSIVE',
  'ADR_RADIOACTIVE',
  'REEFER_HACCP',
  'OVERSIZED',
  'CRANE_OPERATOR',
  'FORKLIFT',
] as const
export type DriverQualification = typeof DRIVER_QUALIFICATIONS[number]
